import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { differenceInSeconds } from 'date-fns';

@Injectable()
export class AuthGuard {
  constructor(private router: Router) {}

  canActivate() {
    if (localStorage.getItem("userLogged")) {
      const payload = JSON.parse(
        atob(localStorage.getItem("userLogged").split(".")[1]),
      );

      if (differenceInSeconds(new Date(payload.exp * 1000), new Date()) >= 0) {
        return true;
      } else {
        console.log("expired");
        this.router.navigate(["/login"]);
        return false;
      }
    }

    console.log("no userlogged");
    this.router.navigate(["/login"]);
    return false;
  }
}
